import { render } from "./CustomEventPropsCmp.vue?vue&type=template&id=9c6f968a"
import script from "./CustomEventPropsCmp.vue?vue&type=script&lang=js"
export * from "./CustomEventPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__